import * as React from "react";
import { Container, Row, Col, Image } from 'react-bootstrap';
import Logo from '../images/logo_white.png';
import { Link } from "gatsby";

const Footer = () => {

    return (
        <section className="section footer">
            <div className="footer-top">
                <Container>
                    <div className="footer-about-us">
                        <Link to="/" className="logo">
                            <Image loading="lazy" className="lazyload" src={Logo} alt="logo" width={143} height={54} />
                        </Link>
                        <p>Our solutions deal all aspects of versatility, but what is even more important to us is bringing value to your business by serving you best, as we treat every project as our own rather than a client.</p>
                        <ul className="list-unstyled footer-menu mb-0">
                            <li className="list-inline-item"><Link to="/about-us">About Us</Link></li>
                            <li className="list-inline-item"><Link to="/cooking-gas-delivery-solution">Cooking Solution</Link></li>
                            <li className="list-inline-item"><Link to="/fuel-delivery-solution">Fuel Solutions</Link></li>
                            <li className="list-inline-item"><Link to="/blog">Blog</Link></li>
                            <li className="list-inline-item"><Link to="/contact">Contact Us</Link></li>
                        </ul>
                    </div>
                    <Row xs={1} md={2} lg={2} className="g-4 mt-4 text-center">
                        <Col className="text-md-start">
                            <p className="m-0 copyright-text">© 2025 GasSwift. All Rights Reserved. <span className="mx-1">|</span> Powered by <a href="https://www.peerbits.com" aria-label="peerbits" className="text-white" rel="noreferrer" target="_blank"> Peerbits</a></p>
                        </Col>
                        <Col className="text-md-end">
                            <div className="social-icon">
                                <a href="https://www.facebook.com/Gasswift-101984098305184/" data-bs-toggle="tooltip" data-bs-placement="top" title="facebook" aria-label="facebook" rel="noreferrer" target="_blank">
                                    <i className="zmdi zmdi-facebook zmdi-hc-lg"></i>
                                </a>
                                <a href="https://twitter.com/GasSwift_" data-bs-toggle="tooltip" data-bs-placement="top" title="twitter" aria-label="twitter" rel="noreferrer" target="_blank">
                                    <svg width={20} height={20} aria-hidden="true" focusable="false" data-prefix="fab" data-icon="x-twitter" className="svg-inline--fa fa-x-twitter " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"></path></svg>
                                </a>
                                <a href="https://www.linkedin.com/company/gasswift/" data-bs-toggle="tooltip" data-bs-placement="top" title="linkedin" aria-label="linkedin" rel="noreferrer" target="_blank">
                                    <i className="zmdi zmdi-linkedin zmdi-hc-lg"></i>
                                </a>
                                <a href="https://www.youtube.com/channel/UC7X9R2bzfPaAURqkx1eecFA" data-bs-toggle="tooltip" data-bs-placement="top" title="youtube" aria-label="youtube" rel="noreferrer" target="_blank">
                                    <i className="zmdi zmdi-youtube-play zmdi-hc-lg"></i>
                                </a>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </section>
    )
}

export default Footer
